import brands from './brands.json';
import wplLogo from '../assets/img/WPL-Global-Blade-Experts-04.png';
import gevLogo from '../assets/img/gev-logo.png';

const logoRegistry = {
  'WPL-Global-Blade-Experts-04.png': wplLogo,
  'gev-logo.png': gevLogo,
};

export function getBrand() {
  const subdomain = window.location.hostname.split('.')[0];
  const config = brands[subdomain] || brands.default;
  return {
    ...config,
    logo: logoRegistry[config.logo] || null,
  };
}
